import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API_BASE, Kind, TOKEN_KEYS } from "@/lib/api";

type Session = { user: any; vendor?: any; plan?: any; profile?: any } | null | undefined;
type Ctx = {
  vendor: Session;
  customer: Session;
  admin: Session;
  signIn: (kind: Kind, token: string) => Promise<void>;
  signOut: (kind: Kind) => void;
  reload: (kind: Kind) => Promise<void>;
};

const AuthCtx = createContext<Ctx>(null as any);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [vendor, setVendor] = useState<Session>(undefined);
  const [customer, setCustomer] = useState<Session>(undefined);
  const [admin, setAdmin] = useState<Session>(undefined);
  const setters = { vendor: setVendor, customer: setCustomer, admin: setAdmin };

  const reload = useCallback(async (kind: Kind) => {
    const set = setters[kind];
    const token = localStorage.getItem(TOKEN_KEYS[kind]);
    if (!token) return set(null);
    try {
      const { data } = await axios.get(`${API_BASE}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      set(data);
    } catch {
      localStorage.removeItem(TOKEN_KEYS[kind]);
      set(null);
    }
  }, []);

  useEffect(() => {
    reload("vendor");
    reload("customer");
    reload("admin");
  }, [reload]);

  const signIn = async (kind: Kind, token: string) => {
    localStorage.setItem(TOKEN_KEYS[kind], token);
    await reload(kind);
  };
  const signOut = (kind: Kind) => {
    localStorage.removeItem(TOKEN_KEYS[kind]);
    setters[kind](null);
  };

  return <AuthCtx.Provider value={{ vendor, customer, admin, signIn, signOut, reload }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
